import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { BoxSelectorContextProps } from './types.js';

export const BoxSelectorContext = createContext<
  BoxSelectorContextProps<'radio' | 'checkbox'> | undefined
>(undefined);

export function BoxSelectorProvider<T extends 'radio' | 'checkbox' = 'radio'>({
  children,
  value,
}: {
  children: ReactNode;
  value: BoxSelectorContextProps<T>;
}) {
  return (
    <BoxSelectorContext.Provider value={value}>
      {children}
    </BoxSelectorContext.Provider>
  );
}

BoxSelectorProvider.displayName = 'BoxSelectorProvider';

export function useBoxSelectorContext<
  T extends 'radio' | 'checkbox' = 'radio',
>(): BoxSelectorContextProps<T> {
  const context = useContext(BoxSelectorContext);
  if (context === undefined) {
    throw new Error(
      'useBoxSelectorItem must be used within a `useBoxSelectorContext`.',
    );
  }

  if (context.type === 'radio' && Array.isArray(context.value)) {
    throw new Error(
      `BoxSelector: Radio group "${context.name}" received array value.
      Radio groups should only have single values.`,
    );
  }
  return context as BoxSelectorContextProps<T>;
}
